<template lang="pug">
  .component-vehicle-additional-status(v-if="item")

    .row.align-middle.align-center(v-if="showToolTip")
      tooltip(v-if="item.door_open_status" :open="true", :position="'right'", :tip="'Door: '+item.door_open_status").has-tip
        span.fa.fa-exclamation.fa-lg(id="door" :class="status(item.door_open_status)")
      tooltip(v-if="item.ev_plug_status" :open="true", :position="'right'", :tip="'ev_plug_status: '+item.ev_plug_status").has-tip
        span.fa.fa-plug.fa-lg(:class="status(item.ev_plug_status)")
      tooltip(v-if="item.key_status" :open="true", :tip="'key_status: '+item.key_status").has-tip
        span.fa.fa-key.fa-lg(:class="status(item.key_status)")
      tooltip(v-if="item.immobilizer_status" :open="true", :tip="'immo_status: '+item.immobilizer_status").has-tip
        span.fa.fa-link.fa-lg(:class="status(item.immobilizer_status)")
      span(v-if="item.battery_voltage")  {{ item.battery_voltage }}V
    .row.align-middle.align-center(v-else)
      span.fa.fa-exclamation.fa-lg(:class="status(item.door_open_status)")
      span.fa.fa-plug.fa-lg(:class="status(item.ev_plug_status)")
      span.fa.fa-key.fa-lg(:class="status(item.key_status)")
      span.fa.fa-link.fa-lg(:class="status(item.immobilizer_status)")
      span(v-if="item.battery_voltage")  {{ item.battery_voltage }}V


</template>
<script type="text/babel">
import Tooltip from 'components/structure/foundation/Tooltip'


export default {
  name: 'VehicleAdditionalStatus',
  components: {Tooltip,},
  data() {
    return {}
  },
  created() {
  },
  methods: {

    status(itemStatus) {
      switch (itemStatus) {
        case 'CHARGING':
        case 'PRESENT':
        case 'CLOSED':
        case 'ENABLED':
          return 'green-status'
        case 'NOT PRESENT':
        case 'OPEN':
        case 'DISABLED':
          return 'red-status'
        case 'CONNECTED':
          return 'orange-status'
        case 'DISCONNECTED':
          return 'grey-status'
      }
    },

  },
  computed: {},
  props: {
    item: {type: Object},
    showToolTip: {type: Boolean, default: true}

  }
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-vehicle-additional-status
  span
    margin: 5px
    font-size: 1.2rem

  .green-status
    color: #27803e

  .red-status
    color: red

  .orange-status
    color: darkorange

  .grey-status
    color: #5e5e5e


//.door-open
//  .fa
//    .fa-unlock:before
//      content: "\f09c"
//      color: #27803e
//      font-size: large



</style>



// WEBPACK FOOTER //
// VehicleAdditionalStatus.vue?5b6a6265